import { FormattedMessage } from "react-intl";
import { LazyLoadImage } from "react-lazy-load-image-component";
import {
  PropertyValuation,
  BuildingProperty,
  FloorProperty,
  UnitProperty,
} from "utils/asset";

const Icon = ({ src, alt }) => <LazyLoadImage src={src} alt={alt} width="16" />;

const propertiesPages = {
  id: "property-group-pages",
  title: <FormattedMessage id="properties" />,
  type: "group",
  children: [
    {
      id: "property",
      title: <FormattedMessage id="property" />,
      type: "item",
      url: "/property",
      icon: () => (
        <Icon src={PropertyValuation} alt="property valuation icon" />
      ),
      subject: "Property",
    },
    {
      id: "building",
      title: <FormattedMessage id="building" />,
      type: "item",
      url: "/building",
      icon: () => <Icon src={BuildingProperty} alt="building property icon" />,
      subject: "Building",
    },
    {
      id: "floor",
      title: <FormattedMessage id="floor" />,
      type: "item",
      url: "/floor",
      icon: () => <Icon src={FloorProperty} alt="floor property icon" />,
      subject: "Floor",
    },
    {
      id: "unit",
      title: <FormattedMessage id="unit" />,
      type: "item",
      url: "/unit",
      icon: () => <Icon src={UnitProperty} alt="unit property icon" />,
      subject: "Unit",
    },
  ],
};

export default propertiesPages;
